module.exports = __webpack_public_path__ + "img/7.67b9cba4.png";